/**
 * Observes elements with `.reveal` class and adds `.is-visible` when
 * they intersect the viewport. One-shot (never removes the class).
 * CSS handles the actual fade/translate via base.css.
 */
export function initReveal(): IntersectionObserver | null {
  if (typeof IntersectionObserver === 'undefined') return null

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' },
  )

  const nodes = document.querySelectorAll<HTMLElement>('.reveal')
  nodes.forEach((node) => observer.observe(node))
  return observer
}
